import React, { FC } from 'react';
import { AnimatedCurrency } from '@hub/components/animated-currency';
import { useTheme } from '@mui/material/styles';
import { LabelWithTooltip } from '../../../../label-with-tooltip';
import { COMPONENT_CONFIG, TYPOGRAPHY_CONFIG } from '../constants';
import { MetricItemContainer } from '../styled';
import type { MetricItemProps } from '../types';

export const ChartMetricItem: FC<MetricItemProps> = ({
  label,
  tooltip,
  value,
  textColor,
  textSize = TYPOGRAPHY_CONFIG.METRIC_LABEL_SIZE,
  labelColor,
}) => {
  const theme = useTheme();

  return (
    <MetricItemContainer>
      <LabelWithTooltip
        label={label}
        tooltip={tooltip}
        showIcon={COMPONENT_CONFIG.SHOW_TOOLTIP_ICON}
        textSize={textSize}
        textColor={labelColor}
      />
      <AnimatedCurrency
        value={value}
        fontSize={TYPOGRAPHY_CONFIG.CURRENCY_FONT_SIZE}
        textColor={textColor || theme.palette.text.second}
        compact={COMPONENT_CONFIG.COMPACT_CURRENCY}
        fontWeight={TYPOGRAPHY_CONFIG.CURRENCY_FONT_WEIGHT}
        currencySymbol={TYPOGRAPHY_CONFIG.CURRENCY_SYMBOL}
        showAnimation={COMPONENT_CONFIG.SHOW_ANIMATION}
        fontStyle={COMPONENT_CONFIG.CURRENCY_FONT_STYLE}
        letterSpacing={TYPOGRAPHY_CONFIG.CURRENCY_LETTER_SPACING}
      />
    </MetricItemContainer>
  );
};
